function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Namespace for date utilities
 *
 * @class DateUtils
 * @static
 */
var DateUtils = /*#__PURE__*/function () {
  function DateUtils() {
    _classCallCheck(this, DateUtils);
  }
  return _createClass(DateUtils, null, [{
    key: "makeRange",
    value:
    /**
     * Returns a date date range created using
     * the provided date and offset.
     *
     * @method DateUtils.makeRange
     * @param {Date} [date=new Date()]
     * @param {Number} [offset=200]
     * @returns {Array}
     */
    function makeRange() {
      var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
      var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;
      return [DateUtils.getOffsetDate(date, offset * -1), DateUtils.getOffsetDate(date, offset)];
    }

    /**
     * Accepts a date and a range (an array containing two dates)
     * and returns a boolean determining whether the provided
     * date is within the provided range.
     *
     * @method DateUtils.dateIsInRange
     * @param {Date} date
     * @param {Date[]} range
     * @returns {Boolean}
     */
  }, {
    key: "dateIsInRange",
    value: function dateIsInRange(date, range) {
      var startDateTime = new Date(range[0]).setHours(0, 0, 0, 0);
      var endDateTime = new Date(range[1]).setHours(0, 0, 0, 0);
      var dateTime = date.getTime();
      return (dateTime >= startDateTime || !range[0]) && (dateTime <= endDateTime || !range[1]);
    }

    /**
     * Returns a boolean that determines whether
     * the provided date is contained within the provided
     * array of dates.
     *
     * @method DateUtils.datesContain
     * @param {Date[]} dates
     * @param {Date} date
     * @returns {Boolean}
     */
  }, {
    key: "datesContain",
    value: function datesContain(dates, date) {
      return dates.filter(function (d) {
        return DateUtils.datesMatch(d, date);
      }).length > 0;
    }

    /**
     * Returns a boolean that determines whether
     * the two provided dates match.
     *
     * @method DateUtils.datesMatch
     * @param {Date} dateOne
     * @param {Date} dateTwo
     * @returns {Boolean}
     */
  }, {
    key: "datesMatch",
    value: function datesMatch(dateOne, dateTwo) {
      if (!dateOne || !dateTwo) {
        return false;
      }
      return dateOne.toDateString() === dateTwo.toDateString();
    }

    /**
     * Returns a padded date digit.
     * Given `1`, this method will return `01`.
     *
     * @method DateUtils.padDateDigit
     * @param {Number} dateNumber
     * @returns {String} dateString
     */
  }, {
    key: "padDateDigit",
    value: function padDateDigit(dateNumber) {
      if (dateNumber < 10) {
        return "0".concat(dateNumber);
      }
      return "".concat(dateNumber);
    }

    /**
     * Returns a boolean that determines whether
     * the provided param is a date or not.
     *
     * @method DateUtils.isDate
     * @param {Date} date
     * @returns {Boolean}
     */
  }, {
    key: "isDate",
    value: function isDate(date) {
      return date instanceof Date;
    }

    /**
     * Returns a boolean that determines whether
     * the provided param is a date or not.
     *
     * @method DateUtils.isDate
     * @param {Date} date
     * @returns {Boolean}
     */
  }, {
    key: "isValidDate",
    value: function isValidDate(date) {
      if (!(date instanceof Date)) {
        return false;
      }
      return !!date.getDate();
    }

    /**
     * Returns a date that uses the provided offset.
     * The offest how many years (+/-) you want to
     * offset the provided date.
     *
     * @method DateUtils.getOffsetDate
     * @param {Date} date
     * @param {Number} [offset=0]
     * @returns {Date}
     */
  }, {
    key: "getOffsetDate",
    value: function getOffsetDate(date) {
      var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var month = date.getMonth();
      var day = date.getDate();
      var year = date.getFullYear();
      return new Date(year + offset, month, day);
    }

    /**
     * Converts a valid string to a date object.
     *
     * @method DateUtils.toDate
     * @param {Date|String} date
     * @returns {Date|String}
     */
  }, {
    key: "toDate",
    value: function toDate(date) {
      // check if date param is valid date object
      if (DateUtils.isValidDate(date) || !date) {
        return date;
      }
      var dateObject = new Date(date);
      // check if newly created date object is valid
      if (DateUtils.isValidDate(dateObject)) {
        return dateObject;
      }
      return date;
    }
  }]);
}();
export { DateUtils as default };